import { render, staticRenderFns } from "./information.vue?vue&type=template&id=a76cc152&scoped=true"
import script from "./information.vue?vue&type=script&lang=js"
export * from "./information.vue?vue&type=script&lang=js"
import style0 from "./information.vue?vue&type=style&index=0&id=a76cc152&prod&lang=css"
import style1 from "./information.vue?vue&type=style&index=1&id=a76cc152&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76cc152",
  null
  
)

export default component.exports